import React from "react";
import SpecialUnit from "./SpecialUnit";

const SpecialBranch = () => <SpecialUnit speId={11} />;

export default SpecialBranch;
